import FileEdit from './FileEdit';
import FileLoader from './FileLoader';

export default {
    Add: FileLoader,
    Edit: FileEdit
};
